import React from 'react';
import DefaultAvatar from '@images/svg/default-avatar.svg?react';
import ReaLogoBadge from '@images/svg/rea-logo-badge.svg?react';
import Verified from '@images/svg/verified.svg?react';
import CalendarIcon from '@images/svg/calendar.svg?react';
import VerifiedStatusIcon from '@images/svg/verified-status.svg?react';
import CurrencyDollarIcon from '@images/svg/currency-dollar.svg?react';
import ChartUpIcon from '@images/svg/chart-up.svg?react';
import BankCardIcon from '@images/svg/bank-card.svg?react';
import TargetAim from '@images/svg/target-aim.svg?react';
import RocketLaunchIcon from '@images/svg/rocket-launch.svg?react';
import FavCircleIcon from '@images/svg/fav-circle.svg?react';
import ShakeHandsLineIcon from '@images/svg/shake-hands-line.svg?react';
import ReaIcon from '@images/svg/rea-icon.svg?react';
import FacebookIcon from '@images/svg/facebook.svg?react';
import ChartSquareBarIcon from '@images/svg/chart-square-bar.svg?react';
import StarOutlinedIcon from '@images/svg/star-outlined.svg?react';
import ConnectIcon from '@images/svg/connect.svg?react';
import ClipboardCheckIcon from '@images/svg/clipboard-check.svg?react';
import MailIcon from '@images/svg/mail.svg?react';
import PhoneIcon from '@images/svg/phone.svg?react';
import ArrowUpRightIcon from '@images/svg/arrow-up-right.svg?react';
import InformationCircleIcon from '@images/svg/information-circle.svg?react';
import ClockIcon from '@images/svg/clock.svg?react';
import CheckSolid from '@images/svg/check-solid.svg?react';
import CloseIcon from '@images/svg/close.svg?react';
import SettlementServiceIcon from '@images/svg/settlement-service.svg?react';
import CloseFilledIcon from '@images/svg/close-filled.svg?react';
import BuyerIcon from '@images/svg/buyer.svg?react';
import PlusIcon from '@images/svg/plus.svg?react';
import SellerIcon from '@images/svg/seller.svg?react';
import CommentIcon from '@images/svg/comment.svg?react';
import CheckOpenCircleIcon from '@images/svg/check-open-circle.svg?react';
import AnnotationIcon from '@images/svg/annotation.svg?react';
import ApproximatelyIcon from '@images/svg/approximately.svg?react';
import DropdownArrowIcon from '@images/svg/dropdown-arrow.svg?react';
import RessLogoIcon from '@images/svg/ress-logo.svg?react';
import NotificationIcon from '@images/svg/notification.svg?react';
import CheckCircleAltIcon from '@images/svg/check-circle-alt.svg?react';
import CloseCircleIcon from '@images/svg/close-circle.svg?react';
import TrophyIcon from '@images/svg/trophy.svg?react';
import ChartDownIcon from '@images/svg/chart-down.svg?react';
import PrimeGoldBadgeIcon from '@images/svg/prime-gold-badge.svg?react';
import StartCheckIcon from '@images/svg/star-check.svg?react';
import CheckCircleIcon from '@images/svg/check-circle.svg?react';
import VisaIcon from '@images/svg/visa.svg?react';
import MastercardIcon from '@images/svg/mastercard.svg?react';
import AmexIcon from '@images/svg/amex.svg?react';
import DiscoverIcon from '@images/svg/discover.svg?react';
import ArrowLeftIcon from '@images/svg/arrow-left.svg?react';
import HelpIcon from '@images/svg/help.svg?react';
import HomeIcon from '@images/svg/home.svg?react';
import CircleIcon from '@images/svg/circle.svg?react';
import ArrowDownIcon from '@images/svg/arrow-down.svg?react';
import ArrowUpIcon from '@images/svg/arrow-up.svg?react';
import UserGroup2Icon from '@images/svg/user-group-2.svg?react';
import BriefCaseIcon from '@images/svg/briefcase.svg?react';
import UserIcon from '@images/svg/user.svg?react';
import FileListIcon from '@images/svg/file-list-line.svg?react';
import SentIcon from '@images/svg/sent.svg?react';
import ReaSmallIcon from '@images/svg/rea-small-icon.svg?react';
import PlusCircleIcon from '@images/svg/plus-circle.svg?react';
import ChevronLeftIcon from '@images/svg/chevron-left.svg?react';
import SearchIcon from '@images/svg/search.svg?react';
import EmptyStateIcon from '@images/svg/empty-state.svg?react';
import InfoCardIcon from '@images/svg/info-card.svg?react';
import SendInviteIcon from '@images/svg/send-invite.svg?react';
import MailAiIcon from '@images/svg/mail-ai.svg?react';
import EyeIcon from '@images/svg/eye.svg?react';
import AiIcon from '@images/svg/ai.svg?react';
import AttachmentIcon from '@images/svg/attachment.svg?react';
import EditIcon from '@images/svg/edit.svg?react';
import EmailSentIcon from '@images/svg/email-sent.svg?react';

const iconMap = {
  'arrow-down': ArrowDownIcon,
  'arrow-up': ArrowUpIcon,
  'calendar': CalendarIcon,
  'currency-dollar': CurrencyDollarIcon,
  'chart-up': ChartUpIcon,
  'bank-card': BankCardIcon,
  'target-aim': TargetAim,
  'default-avatar': DefaultAvatar,
  'rea-logo-badge': ReaLogoBadge,
  'verified': Verified,
  'verified-status': VerifiedStatusIcon,
  'rocket-launch': RocketLaunchIcon,
  'fav-circle': FavCircleIcon,
  'shake-hands-line': ShakeHandsLineIcon,
  'rea': ReaIcon,
  'facebook': FacebookIcon,
  'chart-square-bar': ChartSquareBarIcon,
  'star-outlined': StarOutlinedIcon,
  'connect': ConnectIcon,
  'clipboard-check': ClipboardCheckIcon,
  'mail': MailIcon,
  'phone': PhoneIcon,
  'arrow-up-right': ArrowUpRightIcon,
  'information-circle': InformationCircleIcon,
  'clock': ClockIcon,
  'check-solid': CheckSolid,
  'close': CloseIcon,
  'settlement-service': SettlementServiceIcon,
  'close-filled': CloseFilledIcon,
  'buyer': BuyerIcon,
  'plus': PlusIcon,
  'seller': SellerIcon,
  'comment': CommentIcon,
  'check-open-circle': CheckOpenCircleIcon,
  'annotation': AnnotationIcon,
  'approximately': ApproximatelyIcon,
  'dropdown-arrow': DropdownArrowIcon,
  'ress-logo': RessLogoIcon,
  'notification': NotificationIcon,
  'check-circle-alt': CheckCircleAltIcon,
  'close-circle': CloseCircleIcon,
  'trophy': TrophyIcon,
  'chart-down': ChartDownIcon,
  'prime-gold-badge': PrimeGoldBadgeIcon,
  'star-check': StartCheckIcon,
  'check-circle': CheckCircleIcon,
  'visa': VisaIcon,
  'mastercard': MastercardIcon,
  'amex': AmexIcon,
  'discover': DiscoverIcon,
  'arrow-left': ArrowLeftIcon,
  'help': HelpIcon,
  'home': HomeIcon,
  'circle': CircleIcon,
  'user-group-2': UserGroup2Icon,
  'briefcase': BriefCaseIcon,
  'user': UserIcon,
  'file-list': FileListIcon,
  'sent': SentIcon,
  'rea-small-icon': ReaSmallIcon,
  'plus-circle': PlusCircleIcon,
  'chevron-left': ChevronLeftIcon,
  'search': SearchIcon,
  'empty-state': EmptyStateIcon,
  'info-card': InfoCardIcon,
  'email-sent': EmailSentIcon,
  'send-invite': SendInviteIcon,
  'mail-ai': MailAiIcon,
  'attachment': AttachmentIcon,
  'eye': EyeIcon,
  'ai': AiIcon,
  'edit': EditIcon,
};

export const Icon = (props) => {
  const { type } = props;

  const IconComponent = iconMap[type];

  if (!IconComponent) {
    console.error(`Icon of type [${type}] does not exist`);
    return null;
  }

  return (
    <IconComponent {...props} />
  )
};

export default Icon;
